import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { apiPost } from '../../utils/apiClient';
import './ThankYouPage.css';

export default function ThankYouPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const user = useSelector((s) => s.auth.user);
  const gameKey = params.get('game') || '';
  const fallback = params.get('points');
  const [points, setPoints] = useState(fallback != null ? Number(fallback) : null);

  useEffect(() => {
    // Prefer points from finishGame navigation (0 on replay).
    if (fallback != null) return;
    if (!user?.userId || !gameKey) return;
    (async () => {
      try {
        const res = await apiPost('/game/thankYouPoints', {
          userId: user.userId,
          gameKey,
        });
        setPoints(res.coinsEarned ?? 0);
      } catch {
        /* keep fallback */
      }
    })();
  }, [user, gameKey, fallback]);

  useEffect(() => {
    const t = setTimeout(() => navigate('/hub'), 5000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      className="thankyou-page bg-games"
      style={{ '--page-bg': 'url(/img/games-background.jpg)' }}
    >
      <img src="/img/thanku-img.png" alt="Thank you" className="thankyou-img" />
      <div className="thankyou-score">
        Points earned {points == null ? '—' : points}
      </div>
      <p className="thankyou-sub">Returning to stalls…</p>
    </div>
  );
}
